import { ReactNode } from 'react'

import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

import { NavLink } from './NavLink'

interface NavItemProps {
  icon: ReactNode
  title: string
  path: string
  exact?: boolean
}

export const NavItem = ({ icon, title, path, exact = false }: NavItemProps): JSX.Element => (
  <ListItemButton component={NavLink} end={exact} to={path}>
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText primary={title} />
  </ListItemButton>
)
